import { render, staticRenderFns } from "./SharePublic.vue?vue&type=template&id=0a702d8d&"
import script from "./SharePublic.vue?vue&type=script&lang=ts&"
export * from "./SharePublic.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports